(() => {
  const timers = new WeakMap();
  function update(notice) {
    clearTimeout(timers.get(notice));
    const cutoff = Number(notice.dataset.expiresAt);
    const remaining = cutoff * 1000 - Date.now();
    if (!Number.isSafeInteger(cutoff) || cutoff <= 0 || !Number.isFinite(remaining) || remaining <= 0) {
      notice.hidden = true;
      return;
    }
    notice.hidden = false;
    timers.set(notice, setTimeout(() => update(notice), Math.min(remaining, 86400000)));
  }
  function refresh() {
    document.querySelectorAll('.atna-newlook-notice[data-expires-at]').forEach(update);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, {once:true});
  else refresh();
  document.addEventListener('visibilitychange', refresh);
  document.addEventListener('shopify:section:load', refresh);
})();
